module.exports = __webpack_public_path__ + "static/media/igloo.872d929a.svg";